<template>
  <div class="navbar-container d-flex content align-items-center">
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <Bookmarks v-if="userData" />
    </div>

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <LocaleLink :dropup="false" />

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template
          v-if="userData"
          #button-content
        >
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.name }}
            </p>
            <span class="user-status">{{ $t('adminLabel') }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="userData.pictureUrl"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>{{ $t('navbar.logout') }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { getUserData } from '@/auth/utils'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import LocaleLink from '@/views/components/LocaleLink.vue'
import Bookmarks from './Bookmarks.vue'

export default {
  components: {
    Bookmarks,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
    LocaleLink,
    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      company: null,
      userData: getUserData(),
      locales: [
        { value: 'zh', text: 'Chinese' },
        { value: 'de', text: 'Deutsch' },
        { value: 'en', text: 'English' },
        { value: 'es', text: 'Español' },
        { value: 'fr', text: 'French' },
        { value: 'pl', text: 'Polish' },
        { value: 'pt', text: 'Português(BR)' },
        { value: 'ko', text: 'Korean' },
      ],
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem('userReceiveWelcome')

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>
